<template>
  <div>
    <div class="content">
      <p v-if="errorMessage">{{ errorMessage }}</p>
      <ul>
        <li class="typeli" v-for="type in types" :key="type.title">
          <div class="sectionHeader">
            <div class="header" />
            <h3 class="title">{{ type.title }}</h3>
          </div>
          <ul>
            <li class="typeli" v-for="file in type.data" :key="file.title">
              <p @click="onClick(type.type, file)">{{ file.title }}</p>
            </li>
          </ul>
        </li>
      </ul>
      <div class="model" v-if="show">
        <div
          class="iframe"
          v-bind:style="{
            width: screenWidth + 'px',
            maxWidth: screenWidth + 'px',
          }"
        >
          <iframe
            :src="link_url"
            :width="screenWidth"
            :height="iframeHeight"
            allowfullscreen="true"
          ></iframe>
        </div>
        <button class="button" @click="onClose">关闭</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import CryptoJS from 'crypto-js';
import BaseURL from '../static/config';

export default {
  name: 'Privacy',
  data() {
    return {
      types: [],
      show: false,
      screenWidth: window.innerWidth,
      screenHeigth: 0,
      iframeHeight: 0,
      errorMessage: undefined,
    };
  },
  mounted() {
    const userInfoString = localStorage.getItem('bethel_userinfo');
    const dateString = localStorage.getItem('bethel_login_date');
    if (
      !userInfoString ||
      !dateString ||
      userInfoString.length === 0 ||
      dateString.length === 0
    ) {
      this.$router.replace('/login');
    } else {
      const now = new Date().getTime();
      const date = Number(dateString);
      if ((now - date) / (60 * 60 * 24 * 1000) > 3) {
        this.$router.replace('/login');
      }
    }

    this.screenWidth = window.innerWidth;
    this.screenHeigth = window.innerHeight;
    this.iframeHeight = window.innerHeight - 100;
    const userInfoBytes = CryptoJS.AES.decrypt(
      userInfoString,
      'bethel_mobile_web_key'
    );
    const userInfo = JSON.parse(userInfoBytes.toString(CryptoJS.enc.Utf8));

    if (this.$route.query.code) {
      const codeBytes = CryptoJS.AES.decrypt(
        this.$route.query.code,
        'bethel_mobile_web_key'
      );
      axios
        .post(
          'http://bethelparentws.bethelonline.cn/api/QuestionAuth/GetMaterial2Content',
          {
            CouponCode: codeBytes.toString(CryptoJS.enc.Utf8),
            Language: 'ch',
            MemberID: userInfo.user_id,
          },
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${userInfo.token}`,
            },
          }
        )
        .then((res) => {
          const ppt = {
            type: 'ppt',
            title: 'PPT',
            data: [],
            index: 1,
          };
          const pdf = {
            type: 'pdf',
            title: 'PDF',
            data: [],
            index: 2,
          };
          const video = {
            type: 'video',
            title: '视频',
            data: [],
            index: 3,
          };
          const url = {
            type: 'url',
            title: '网页',
            data: [],
            index: 4,
          };

          const fileObject = {
            pdf,
            video,
            ppt,
            url,
          };

          res.data.forEach((f) => {
            fileObject[f.type_text].data.push(f);
          });
          const finalArray = [];
          if (video.data.length > 0) {
            finalArray.push({
              ...video,
              data: video.data.reverse(),
            });
          }
          if (ppt.data.length > 0) {
            finalArray.push({
              ...ppt,
              data: ppt.data.reverse(),
            });
          }
          if (pdf.data.length > 0) {
            finalArray.push({
              ...pdf,
              data: pdf.data.reverse(),
            });
          }
          if (url.data.length > 0) {
            finalArray.push({
              ...url,
              data: url.data.reverse(),
            });
          }
          const types = finalArray.sort((a, b) => {
            if (a.index < b.index) {
              return -1;
            } else if (a.index > b.index) {
              return 1;
            }
            return 0;
          });
          this.types = types;
        })
        .catch(() => {
          this.errorMessage = '请求错误, 请查看课件码是否正确';
        });
    } else {
      const mIdBytes = CryptoJS.AES.decrypt(
        this.$route.query.mId,
        'bethel_mobile_web_key'
      );

      axios
        .get(
          `${BaseURL}material_authentications/${mIdBytes.toString(
            CryptoJS.enc.Utf8
          )}`,
          {},
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${userInfo.token}`,
            },
          }
        )
        .then((res) => {
          console.log('----', res.data.file_sources);
          this.types = [
            {
              type: 'scource',
              title: '资源',
              data: res.data.file_sources,
            },
          ];
        });
    }
  },
  methods: {
    onClick(type, file) {
      this.show = true;
      if (type === 'video') {
        this.link_url = `http://app.ourbethel.cn:8082/#/video_player?screenWidth=${window.innerWidth}&videoId=${file.main_url}`;
      } else if (type === 'pdf' || type === 'ppt' || type === 'url') {
        this.link_url = file.main_url;
      }
    },
    onClose() {
      this.show = false;
    },
  },
};
</script>

<style scoped>
li {
  padding: 10px 0px;
  text-align: left;
}

.model {
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  background-color: white;
  display: flex;
  justify-items: center;
  align-items: center;
  flex-direction: column;
}

.typeli {
  list-style: none;
}

.header {
  background-color: red;
  margin-right: 10px;
  display: inline-block;
  width: 10px;
  height: 20px;
}

.sectionHeader {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.button {
  height: 40px;
  width: 320px;
  border-radius: 20px;
  outline: none;
  border: #d5d5d5 1px solid;
  margin-top: 20px;
  background-color: #49afad;
  color: white;
  font-size: 14;
}
.content {
  display: flex;
  background-color: #f7f7f7;
  width: 100vw;
  justify-content: center;
  align-items: center;
}
</style>
